/**
 * Browser autofill often ignores autoComplete="off".
 * These attributes reduce Chrome / password-manager autofill on dynamic forms.
 *
 * Never bind a permanent React `readOnly` prop for antifill: parent setState on
 * each keystroke re-applies it and jumps the caret to the end (Email / TextBox).
 */
export const antiAutofillProps = {
  autoComplete: "new-password",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false as boolean,
  "data-lpignore": "true",
  "data-1p-ignore": "true",
  "data-form-type": "other",
  "data-bwignore": "true",
};

/** Prefer text+inputMode over type=email so browsers do not email-autofill. */
export const resolveInputType = (type?: string) =>
  type === "email" ? "text" : type ?? "text";

export const resolveInputMode = (type?: string) =>
  type === "email" ? "email" : undefined;
